"use client";
import { jsx } from 'react/jsx-runtime';
import { faXmark } from '@optimizely/pro-light-svg-icons';
import { faXmark as faXmark$1 } from '@optimizely/pro-thin-svg-icons';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Icon } from '../Icon/icon.js';

const CloseButton = ({ className, onClick, size, ...props }) => {
  const closeIcon = size === "small" ? faXmark : faXmark$1;
  return /* @__PURE__ */ jsx(
    "button",
    {
      className: classNames("oui-close-button", className),
      onClick,
      type: "button",
      ...props,
      children: /* @__PURE__ */ jsx(Icon, { icon: closeIcon, size })
    }
  );
};
CloseButton.propTypes = {
  /** CSS class names. */
  className: PropTypes.string,
  /**
   *  Function to perform when the close button is clicked.
   */
  onClick: PropTypes.func.isRequired,
  /**
   *  Size of the close button.
   */
  size: PropTypes.oneOf(["small", "medium", "large"])
};
CloseButton.defaultProps = {
  size: "medium"
};

export { CloseButton as default };
